import styled, { css } from 'styled-components';

import Button from '../Button';
const ImgWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 32px;
  img {
    width: 300px;
  }
  @media screen and (max-width: 500px) {
    justify-content: flex-start;
  }
`;
const IntroWrap = styled.div`
  background: rgba(215, 241, 254, 1);
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
const IconWrap = styled.div`
  border-radius: 8px;
  background: rgba(192, 227, 245, 1);
  padding: 16px;
  border: 1px solid rgba(33, 170, 232, 1);
  margin-right: 32px;
`;

const Box = styled.div`
  background: ${(props) =>
    props.theme === 'green'
      ? 'rgba(222, 242, 233, 1)'
      : 'rgba(249, 249, 249, 1)'};
  border: 1px solid rgba(207, 215, 225, 1);
  border-radius: 8px;
  margin-bottom: 16px;
  padding: 32px;
  min-height: calc(100% - 16px);
  ${(props) => {
    if (props.theme === 'green') {
      return css`
        background: rgba(222, 242, 233, 1);
      `;
    } else if (props.theme === 'blue') {
      return css`
        background: rgba(37, 179, 235, 0.6);
      `;
    }
    return css`
      background: rgba(249, 249, 249, 1);
    `;
  }};
`;
const Download = styled(Button)`
  background: white;
  border: 1px solid black;
  color: black;
  text-transform: none;

  font-weight: 400;
`;
export default {
  ImgWrap,
  IntroWrap,
  IconWrap,
  Box,
  Download,
};
